module.exports = __webpack_public_path__ + "f7d5291f6eb512e57220b34a109f3070.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/news/img1_3.jpg
// module id = 343
// module chunks = 0